export const categoryMeta = {
  "doctors/homeopathic-doctors-online": {
    title:
      "Online Homeopathy Doctors | Consult Certified Homeopaths at Holypills",
    description:
      "Book an online consultation with certified homeopathy doctors at Holypills. Get natural and holistic treatments for women’s health issues like PCOS, Endometriosis, Menopause, and Postpartum care.",
    canonical: "https://holypills.in/doctors/homeopathic-doctors-online",

    "og:type": "article",
    "og:title":
      "Online Homeopathy Doctors | Consult Certified Homeopaths at Holypills",
    "og:description":
      "Book an online consultation with certified homeopathy doctors at Holypills. Get natural and holistic treatments for women’s health issues like PCOS, Endometriosis, Menopause, and Postpartum care.",
    "og:url": "https://holypills.in/doctors/homeopathic-doctors-online",
    "og:site_name": "Holypills",

    "twitter:card": "summary_large_image",
    "twitter:title":
      "Postpartum Care with Holypills: Recover Naturally with Homeopathy",
    "twitter:description":
      "Book an online consultation with certified homeopathy doctors at Holypills. Get natural and holistic treatments for women’s health issues like PCOS, Endometriosis, Menopause, and Postpartum care.",
    "twitter:url": "https://holypills.in/doctors/homeopathic-doctors-online",
  },

  "doctors/consult-with-nutritionist-online": {
    title: "Consult Online Nutritionists & Dietitians | Holypills",
    description:
      "Consult certified nutritionists online for personalized diet plans, weight management, and women’s health. Book your expert session today.",
    canonical: "https://holypills.in/doctors/consult-with-nutritionist-online",

    "og:type": "article",
    "og:title": "Consult Online Nutritionists & Dietitians | Holypills",
    "og:description":
      "Consult certified nutritionists online for personalized diet plans, weight management, and women’s health. Book your expert session today.",
    "og:url": "https://holypills.in/doctors/consult-with-nutritionist-online",
    "og:site_name": "Holypills",

    "twitter:card": "summary_large_image",
    "twitter:title": "Consult Online Nutritionists & Dietitians | Holypills",
    "twitter:description":
      "Consult certified nutritionists online for personalized diet plans, weight management, and women’s health. Book your expert session today.",
    "twitter:url":
      "https://holypills.in/doctors/consult-with-nutritionist-online",
  },
  
  "doctors/fitness-expert-online": {
    title: "Online Fitness Experts & Trainers | Holypills",
    description:
      "Consult online fitness experts at Holypills for personalized training, weight management, injury recovery & lifestyle guidance. Book sessions with certified trainers.",
    canonical: "https://holypills.in/doctors/fitness-expert-online",

    "og:type": "article",
    "og:title": "Online Fitness Experts & Trainers | Holypills",
    "og:description":
      "Consult online fitness experts at Holypills for personalized training, weight management, injury recovery & lifestyle guidance. Book sessions with certified trainers.",
    "og:url": "https://holypills.in/doctors/fitness-expert-online",
    "og:site_name": "Holypills",
  },
};
